import { render, staticRenderFns } from "./allocationControl.vue?vue&type=template&id=563a7a07&"
import script from "./allocationControl.vue?vue&type=script&lang=js&"
export * from "./allocationControl.vue?vue&type=script&lang=js&"
import style0 from "./allocationControl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "allocationControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VContainer,
  VDialog,
  VFlex,
  VIcon,
  VLayout,
  VTextField,
  VTooltip,
})
